import type { InferField as Infer } from './fields/Infer';

export type { Infer };
